<template>
  
  <div>
  
    <m-row class="align-items-center mb-4 mt-8">
      <m-col sm="6" class="d-flex justify-end">
        <memlist-icon-button
          icon="menu-icon flaticon2-plus"
          :text="$t('DONATION.CREATE_DONATION')"
          variant="primary"
          @click="create_form_clicked"
        />
      </m-col>
    </m-row>

    <memlist-static-table
      id="donation-table"
      :fields="headers"
      :items="items"
      ref="donation-table"
    >

      <template #cell(actions)="row">
        <div class="justify-content-end d-flex">

          <memlist-table-button class="mr-3" @click="copy_link_clicked(row.item)" svg="/assets/svg/Directions.svg" :tooltip="$t('DONATION.COPY_TEST_LINK')" />
          <memlist-table-button class="mr-3" @click="select_form_clicked(row.item.id)" svg="/assets/svg/pencil-square.svg" :tooltip="$t('DONATION.TOOLTIP_EDIT')" />
          <memlist-table-button class="mr-3" @click="delete_form_clicked(row.item.event_id)" svg="/assets/svg/trash2.svg" :tooltip="$t('DONATION.TOOLTIP_DELETE')" />
        
        </div>
      </template>
    </memlist-static-table>
      
  </div>
</template>

<style lang="scss" scoped>



</style>
<script>


import { get_domain_url, downloadWithAxios } from '@/core/services/fileDownload';
import { toasts } from '@/core/mixins/toastr-helper.mixin.js';

export default {
  name: 'DonationsTable',
  props: ['items', 'currentCompanyId'],
  emits: ['select_form_clicked', 'delete_form_clicked'],
  mixins: [ toasts ],
  components: {  },
  methods: {
    create_form_clicked() {
      this.$emit('create_form_clicked');
    },

    copy_link_clicked(item) {

      const link = `${get_domain_url()}/test/iframe/donation/button/${item.linkstr}`;

      navigator.clipboard
        .writeText(link)
        .then(() => {
          this.toastr('success', this.$t('COMMON.OK') , this.$t('FORM.COPIED'));
        })
        .catch(() => {
          this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('FORM.UNABLE_COPY'));
        });

    },

    select_form_clicked(id) {
      this.$emit('select_form_clicked', id);
    },

    delete_form_clicked(id) {
      this.$emit('delete_form_clicked', id);
    },

  },
  data() {
    return {
      current_page: 1,
      per_page: 100,
      options: [100, 150, 200],
      headers: [
        {
          key: 'name',
          label: this.$t('DONATION.DONATION'),
          sortable: true,
          thClass: '',
          tdClass: 'td-contain'
        },
        {
          key: 'created_at',
          label: this.$t('FORM.CREATED_AT'),
          sortable: true,
          thClass: 'pl-7',
          tdClass: 'pl-7'
        },
        {
          key: 'actions',
          label: this.$t('COMMON.ACTIONS'),
          thClass: 'w-150px pr-22'
        }
      ],
      list: []
    };
  }
};
</script>
